import views from '@/views/';

export default [
  {
    component: views.member.memberList,
    label: '会员列表',
    path: 'memberlist',
    name: 'memberList',
  },
  {
    component: views.member.newMember,
    label: '新建会员',
    path: 'newmember',
    name: 'newMember',
    menuHidden: true,
  },
  {
    component: views.member.labelSet,
    label: '标签查看',
    path: 'labelset',
    name: 'labelSet',
  },
  {
    component: views.member.smsPurchase,
    label: '短信购买',
    path: 'smspurchase',
    name: 'smsPurchase',
  },
  {
    component: views.member.smsRecord,
    label: '消息记录',
    path: 'smsrecord',
    name: 'smsRecord',
  },
  {
    component: views.member.couponRecord,
    label: '优惠券记录',
    path: 'couponrecord',
    name: 'couponRecord',
  },
  {
    component: views.member.memberDetail,
    label: '会员详情',
    path: 'memberDetail',
    name: 'memberDetail',
    menuHidden: true,
  },
];
